import React from "react";
import "./webinarLandingPage.css";

const WebinarThankuAshtalakshmi = () => {
  return (
    <div className="thankyou-container">
  <div className="thankyou-card">
    <h1 className="thankyou-title">🙏 Thank You!</h1>
    <p className="thankyou-subtitle">
      Thank you for registering for the Myomanamo Ashtalakshmi Homam!
    </p>

    <div className="thankyou-details">
      <h2>📌 Webinar Information</h2>
      <ul>
        <li><strong>Date :</strong> 27 September
                        2025</li>
        <li><strong>Time :</strong> 4:00 pm –
                        6:00 pm</li>
      
        
        <li><strong>Attend :</strong> Through the
                        live-streaming link.</li>
        <li><strong>Booking Charges : </strong> ₹
                        750/- per family.</li>
      </ul>
    </div>

    <div className="thankyou-note">
      <p>✅ Add this event to your calendar so you don't miss it.</p>
      <p>
        📧 You will receive a separate email/WhatsApp message closer to the event date with the live streaming link to join the webinar.
      </p>
    </div>
  </div>
</div>

  );
};

export default WebinarThankuAshtalakshmi;
